export const capitalizeFilter = (str) => {
	if (typeof str == 'string') {
		if (str == 'custom-value') {
			return 'Custom Value'
		}
		return `${str[0].toUpperCase()}${str.slice(1)}`
	}
}



// WEBPACK FOOTER //
// ./src/utils/filters/capitalize.js